import { Button } from 'grommet';
import styled from 'styled-components';

const CustomButton = styled(Button)`
  font-weight: ${(props) => (props.bold ? '600' : '400')};
`;

export default CustomButton;
